/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabasePeriodFieldLook = {
    DateFieldDateAndTimeLook: 'DATE_FIELD_DATE_AND_TIME_LOOK',
    OnlyDateLook: 'ONLY_DATE_LOOK',
    DateFieldOnlyDateLook: 'DATE_FIELD_ONLY_DATE_LOOK',
    DateFieldOnlyTimeLook: 'DATE_FIELD_ONLY_TIME_LOOK',
    PeriodFieldOnlyYearLook: 'PERIOD_FIELD_ONLY_YEAR_LOOK',
    PeriodFieldPlainStringLook: 'PERIOD_FIELD_PLAIN_STRING_LOOK'
} as const;
export type DatabasePeriodFieldLook = typeof DatabasePeriodFieldLook[keyof typeof DatabasePeriodFieldLook];


export function DatabasePeriodFieldLookFromJSON(json: any): DatabasePeriodFieldLook {
    return DatabasePeriodFieldLookFromJSONTyped(json, false);
}

export function DatabasePeriodFieldLookFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasePeriodFieldLook {
    return json as DatabasePeriodFieldLook;
}

export function DatabasePeriodFieldLookToJSON(value?: DatabasePeriodFieldLook | null): any {
    return value as any;
}

